export default __webpack_public_path__ + "static/icon-8-1-7a9d648262f865a5e7563e72de6f3f24.png";